export type ImplantPreferenceValues = {
  favoriteSystems: string[];
  defaultSystem: string | null;
  platform: string | null;
  retentionMode: string;
  crownMaterial: string | null;
  emergenceProfile: string | null;
  passiveFitKey: string;
  ceramicGingiva: string;
  allOnFramework: string | null;
  allOnTeethMaterial: string | null;
  falseGingiva: string;
};

export const getImplantPreferenceDefaults = (): ImplantPreferenceValues => ({
  favoriteSystems: [],
  defaultSystem: null,
  platform: null,
  retentionMode: "",
  crownMaterial: null,
  emergenceProfile: null,
  passiveFitKey: "",
  ceramicGingiva: "",
  allOnFramework: null,
  allOnTeethMaterial: null,
  falseGingiva: "",
});
